import React from 'react';
import { MenuToggle } from '../styles/menu-icon.style';
/**
 * Menu Icon Component
 * @param {object} props Incoming props
 * @returns {XML} Menu Component
 */
const MenuIcon = props => (
  <MenuToggle
    className="nav__links-toggle mobile-only"
    onClick={() => {
      props.onClick();
    }}
    onKeyDown={(e) => {
      if (e.which === 13 || e.keyCode === 13) props.onClick();
    }}
    role="button"
    tabIndex="0"
  >
    <svg
      className="circle-svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="58"
      height="58"
    >
      <circle className="circle-svg__circle" r="19" cx="50%" cy="50%" strokeDasharray="1, 6" />
      <circle className="circle-svg__circle circle-svg__circle--big" r="27" cx="50%" cy="50%" strokeDasharray="1, 3" />
    </svg>
    { 'Toggle Menu' }
  </MenuToggle>
);

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/components/menu-item/components/menu-icon.js